function openUrl(url){window.location.href = url};
export default openUrl;